export const STATE = '[State]';

export const GET_STATES_SAGA = `${STATE} GET_STATES_SAGA`;
export const SET_STATES = `${STATE} SET_STATES`;
